export default __webpack_public_path__ + "static/media/me6.59e52131.gif";